import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import {Institution} from "../../../models/institution";
import {InstitutionControllerService} from "../../../services/institution-controller/institution-controller.service";
import {RegistrationInstitutionControllerService} from "../../../services/institution-controller/institution-registration-controller.service";
import {ModalService} from "../../utils/base_modal.component";
import {environment} from "../../../../environments/environment";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "institutions-table",
  templateUrl: "./institutions-table.component.html",
  providers: [InstitutionControllerService, ModalService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class InstitutionsTableComponent extends TranslatedBaseError implements OnInit {
  @Input() public hideList: boolean = false;
  public serviceId: string;
  public determinantMapById: { [key: string]: string } = {};
  public baseUrl: string;
  public institutions: any[] = [];

  public style: object = {};
  public institution: any;
  public showEdit: boolean = false;
  public showAdd: boolean = false;
  public newCustomFilterBy: string;
  public elementsNumber: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private registrationInstitutionControllerService: RegistrationInstitutionControllerService,
              private determinantService: DeterminantControllerService,
              private institutionControllerService: InstitutionControllerService, toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/institutionstable";
      this.getServiceDeterminantKeyName();
    });
    this.getInstitutions();
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public delete(institution) {
    this.deleteInstitution(institution);
  }

  public deleteInstitution(institution: Institution) {
    this.registrationInstitutionControllerService.getRegistrationInstitutionsByInstitutionId(institution.id).subscribe(
      (data) => {
        if (data != null && data.length > 0) {
          this.error("", "Can not delete institution " + institution.name + " before relation is deleted! ");
        } else {
          this.institutionControllerService.deleteInstitution(institution).subscribe(
            () => {
              this.responseSuccessful("Institution deleted!");
              this.ngOnInit();
              this.router.navigate(["/services/" + this.serviceId + "/institutionstable"]);
            },
            (error) => this.showErrorMessage(error),
          );
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public update(item) {
    return this.institutionControllerService.updateInstitution(item).subscribe(
      (data) => {
        item.isInRenameMode = false;
        item.isLoading = false;
        this.responseSuccessful("Institution saved!");
      },
      (error) => {
        this.ngOnInit();
        return this.showErrorMessage(error);
      },
    );
  }

  public getInstitutions() {
    this.institutionControllerService.getInstitutions().subscribe(
      (data) => {
        this.institutions = data;
        this.elementsNumber = " (" + this.institutions.length + ")";
      },
      (error) => this.showErrorMessageWithTitle("Unable to get Institutions list", error),
    );
  }

  public onNewFilterBy(value) {
    this.newCustomFilterBy = value;
  }

  public loadInstitution(institution) {
    if (institution) {
      if (Boolean(environment.KEYCLOAK_ACTIVE)) {
        return this.institutionControllerService.getInstitution(institution.id).subscribe(
            (inst) => {
              this.institution = inst;
              this.showEdit = true;
            });
      }
      this.institution = this.institutions.find((it) => {
        return it.id === institution.id;
      });
      this.showEdit = true;
    } else {
      this.institution = new Institution();
      this.institution.name = this.newCustomFilterBy;
      this.institution.shortName = this.newCustomFilterBy ? this.newCustomFilterBy.substring(0, 20) : "";
      this.showAdd = true;
    }
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getInstitutions();
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

}
